import { render } from "./layout3.vue?vue&type=template&id=f1a9514a"
import script from "./layout3.vue?vue&type=script&lang=js"
export * from "./layout3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__